/* Massimo Castelli - Private label collection builder v2 (09.10.2026: document-level events; prototypes in step 01, access rule in snippets/mc-proto-access.liquid)
   01 model -> 02 leather type + colour (swatches or code from the real card photo) -> 03 logo -> 04 quantity.
   Fixed bottom bar with progress, auto-scroll to the next step, items saved through window.MCCollection. */
(function () {
  var root = document.getElementById('mcpl');
  if (!root) return;

  var MIN_QTY = 10;
  var FAMS = window.MC_LEATHERS || [];
  var FILES = root.getAttribute('data-files-base') || '';
  var GROUPS = [['all', 'All'], ['neutral', 'Whites, greys & black'], ['brown', 'Beiges & browns'], ['red', 'Reds & pinks'],
    ['orange', 'Yellows & oranges'], ['green', 'Greens'], ['blue', 'Blues'], ['purple', 'Purples'], ['metallic', 'Metallic']];
  var LOGOS = [['Blind hot stamp', 'Your logo debossed into the leather, no colour.'], ['Gold foil', 'Hot stamp with gold foil.'],
    ['Silver foil', 'Hot stamp with silver foil.'], ['Not sure yet', 'We will advise you on the best finish.']];

  var S = { model: null, fam: 0, leather: null, logo: null, qty: MIN_QTY, type: 'All', group: 'all', q: '' };
  var models = [];

  /* always look elements up fresh: some apps (price hiding) rewrite the page HTML after load */
  function $(s) { return document.querySelector(s) || { set innerHTML(v) {}, set textContent(v) {}, set disabled(v) {}, value: '' }; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function sized(u, w) {
    if (!u) return '';
    u = u.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function card(fn) { return fn ? FILES + fn : ''; }
  function go(id) {
    var el = document.getElementById(id);
    if (el && el.scrollIntoView) setTimeout(function () { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 120);
  }
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }

  /* ---------- 01 models (+ prototypes from metaobjects, only for customers tagged 'prototypes') ---------- */
  var PROTO = 'New ideas';
  var protoOk = root.getAttribute('data-proto-access') === '1';
  var protoWa = root.getAttribute('data-proto-wa') || 'https://wa.me/393332177830';
  var protos = [];
  try { var pe = document.getElementById('mcpl-protos'); if (pe) protos = JSON.parse(pe.textContent) || []; } catch (e) { protos = []; }
  var st0 = document.createElement('style');
  st0.textContent = '.mcpl-model__img{position:relative}.mcpl-badge{position:absolute;top:.8rem;left:.8rem;background:#6b1e2e;color:#f5efe6;font-size:1.05rem;font-weight:600;letter-spacing:.08em;text-transform:uppercase;padding:.3rem .9rem;border-radius:999px}' +
    '.mcpl-lock{grid-column:1/-1;background:#f5efe6;color:#2a1a1c;border-radius:1.4rem;padding:2.4rem;font-size:1.5rem;line-height:1.6}.mcpl-lock b{display:block;font-size:2rem;font-weight:500;margin-bottom:.6rem}.mcpl-lock a{display:inline-block;margin-top:1.4rem;background:#6b1e2e;color:#f5efe6;border-radius:999px;padding:1.1rem 2.2rem;text-decoration:none;font-weight:600;font-size:1.4rem}';
  document.head.appendChild(st0);

  var url = root.getAttribute('data-products-url');
  function page(p) {
    return fetch(url + '?limit=250&page=' + p).then(function (r) { return r.json(); })
      .then(function (j) { return j.products || []; }).catch(function () { return []; });
  }
  Promise.all([page(1), page(2)]).then(function (res) {
    var seen = {};
    res[0].concat(res[1]).forEach(function (p) {
      var t = p.title || '';
      var name = t.split(' ')[0].toUpperCase(); if (!name) return;
      var colour = t.indexOf(' - ') > -1 ? t.split(' - ').pop() : '';
      var img = p.images && p.images[0] ? p.images[0].src : '';
      if (!seen[name]) { seen[name] = { name: name, type: p.product_type || 'Other', img: img, colours: {} }; models.push(seen[name]); }
      if (colour && img) seen[name].colours[norm(colour)] = { name: colour, img: img };
    });
    models.sort(function (a, b) { return a.name.localeCompare(b.name); });
    protos.forEach(function (p) {
      var n = String(p.name || '').toUpperCase(); if (!n) return;
      var im = p.img || ''; if (im.indexOf('//') === 0) im = 'https:' + im;
      models.unshift({ name: n, type: PROTO, img: im, colours: {}, proto: true });
    });
    renderTypes(); renderModels();
  });
  function renderTypes() {
    var types = ['All'];
    models.forEach(function (m) { if (types.indexOf(m.type) < 0 && m.type !== PROTO) types.push(m.type); });
    types.push(PROTO);
    $('#mcpl-types').innerHTML = types.map(function (t) {
      return '<button type="button" class="mcpl-pill' + (t === S.type ? ' is-on' : '') + '" data-type="' + esc(t) + '">' + esc(t) + '</button>';
    }).join('');
  }
  function renderModels() {
    var q = S.q.toUpperCase();
    if (S.type === PROTO && (!protoOk || !protos.length)) {
      $('#mcpl-models').innerHTML = '<div class="mcpl-lock">' + (protoOk ?
        '<b>New ideas are coming soon</b>We will show you our next shapes here, before they reach the catalogue.' :
        (root.getAttribute('data-proto-login') === '1' ?
          '<b>Unlock our new ideas</b>Add your company name and phone number to your account: access is immediate once your details are saved.<br><a href="' + esc(protoWa) + '">Complete my account</a>' :
          '<b>New ideas are reserved to business partners</b>Log in or register to see new shapes in development, before they reach the catalogue.<br><a href="' + esc(protoWa) + '">Log in</a>')) + '</div>';
      return;
    }
    var list = models.filter(function (m) { return (S.type === 'All' || m.type === S.type) && (!q || m.name.indexOf(q) > -1); });
    $('#mcpl-models').innerHTML = list.length ? list.map(function (m) {
      var on = S.model && S.model.name === m.name;
      return '<button type="button" class="mcpl-model' + (on ? ' is-on' : '') + '" data-name="' + esc(m.name) + '">' +
        '<span class="mcpl-model__img">' + (m.proto ? '<span class="mcpl-badge">New idea</span>' : '') + (m.img ? '<img src="' + esc(sized(m.img, 360)) + '" alt="' + esc(m.name) + '" loading="lazy">' : '') + '</span>' +
        '<span class="mcpl-model__t">' + esc(m.name) + '</span><span class="mcpl-model__s">' + (m.proto ? 'In development' : esc(m.type)) + '</span></button>';
    }).join('') : '<p class="mcpl-empty">' + (models.length ? 'No models match your search.' : 'Loading models…') + '</p>';
  }

  /* ---------- 02 leather type + colour ---------- */
  function renderFams() {
    $('#mcpl-fams').innerHTML = FAMS.map(function (f, i) {
      var th = f.cards && f.cards[0] ? card(f.cards[0]) : '';
      var cnt = f.colours && f.colours.length ? f.colours.length + ' colours' : 'See colour card';
      return '<button type="button" class="mcpl-fam-c' + (i === S.fam ? ' is-on' : '') + '" data-fam="' + i + '">' +
        '<span class="mcpl-fam-c__img">' + (th ? '<img src="' + esc(sized(th, 300)) + '" alt="" loading="lazy" onerror="this.remove()">' : '') + '</span>' +
        '<b>' + esc(f.name) + '</b><small>' + cnt + '</small></button>';
    }).join('');
  }
  function renderColours() {
    var f = FAMS[S.fam]; if (!f) return;
    var hasList = f.colours && f.colours.length;
    var hasMetal = hasList && f.colours.some(function (c) { return c.g === 'metallic'; });
    var hasGroups = hasList && f.colours.some(function (c) { return c.g; });
    $('#mcpl-groups').innerHTML = hasGroups ? GROUPS.filter(function (g) { return g[0] !== 'metallic' || hasMetal; }).map(function (g) {
      return '<button type="button" class="mcpl-pill' + (g[0] === S.group ? ' is-on' : '') + '" data-group="' + g[0] + '">' + g[1] + '</button>';
    }).join('') : '';
    var html = '';
    if (f.cards && f.cards.length) {
      html += '<button type="button" class="mcpl-cardbtn" data-cards="' + S.fam + '">View the real ' + esc(f.name) + ' colour card (' + f.cards.length + ' photos) →</button>';
    }
    if (hasList) {
      html += '<div class="mcpl-sw">';
      f.colours.forEach(function (c, ci) {
        if (hasGroups && S.group !== 'all' && c.g !== S.group) return;
        var on = S.leather && S.leather.fam === S.fam && S.leather.ci === ci;
        html += '<button type="button" class="mcpl-sw__i' + (c.g === 'metallic' ? ' is-metal' : '') + (on ? ' is-on' : '') +
          '" data-leather="' + ci + '" title="' + esc((c.c ? c.c + ' ' : '') + c.n) + '"><span class="mcpl-sw__c" style="background:' + esc(c.h || '#ddd') + '"></span>' +
          '<span class="mcpl-sw__n">' + esc(c.n) + '</span><span class="mcpl-sw__k">' + esc(c.c) + '</span></button>';
      });
      html += '</div>';
    }
    var manual = S.leather && S.leather.fam === S.fam && S.leather.ci < 0 ? S.leather.name : '';
    html += '<div class="mcpl-manual"><label for="mcpl-code">' + (hasList ? 'Or type the colour code you see on the card' : 'Open the colour card and type the code and name of the colour you want') +
      '</label><div><input id="mcpl-code" type="text" placeholder="e.g. S28 Nero" value="' + esc(manual) + '"><button type="button" class="mcpl-pill" data-code-ok>Use this colour</button></div></div>';
    html += '<p class="mcpl-note">Swatches on screen are indicative: the colour card photos show the real leathers.</p>';
    $('#mcpl-leathers').innerHTML = html;
  }

  /* lightbox with the real colour card photos */
  var lb = document.createElement('div');
  lb.className = 'mcpl-lb'; lb.hidden = true;
  lb.innerHTML = '<div class="mcpl-lb__in"><div class="mcpl-lb__hd"><b></b><button type="button" class="mcpl-lb__x" aria-label="Close">×</button></div><div class="mcpl-lb__bd"></div></div>';
  document.body.appendChild(lb);
  function openCards(i) {
    var f = FAMS[i];
    lb.querySelector('b').textContent = f.name + ' – colour card';
    lb.querySelector('.mcpl-lb__bd').innerHTML = f.cards.map(function (fn) {
      return '<a href="' + esc(card(fn)) + '" target="_blank" rel="noopener"><img src="' + esc(sized(card(fn), 1600)) + '" alt="' + esc(f.name) + ' colour card" loading="lazy"></a>';
    }).join('') + '<p class="mcpl-note">Tap a photo to open it full size and zoom. Then type the colour code in the builder.</p>';
    lb.hidden = false; document.documentElement.style.overflow = 'hidden';
  }
  function closeCards() { lb.hidden = true; document.documentElement.style.overflow = ''; }
  lb.addEventListener('click', function (e) { if (e.target === lb || e.target.closest('.mcpl-lb__x')) closeCards(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lb.hidden) closeCards(); });

  /* ---------- 03 logo ---------- */
  function renderLogos() {
    $('#mcpl-logos').innerHTML = LOGOS.map(function (l) {
      return '<button type="button" class="mcpl-logo' + (S.logo === l[0] ? ' is-on' : '') + '" data-logo="' + esc(l[0]) + '"><b>' + esc(l[0]) + '</b><span>' + esc(l[1]) + '</span></button>';
    }).join('');
  }

  /* ---------- bar ---------- */
  function realImg() {
    if (!S.model) return '';
    if (S.leather) {
      var k = norm(S.leather.colourName || S.leather.name);
      var hit = S.model.colours[k];
      if (!hit) { for (var key in S.model.colours) { if (k && (key.indexOf(k) > -1 || k.indexOf(key) > -1)) { hit = S.model.colours[key]; break; } } }
      if (hit) return hit.img;
    }
    return S.model.img;
  }
  function renderBar() {
    var m = S.model, l = S.leather, ok = m && l && S.logo && S.qty >= MIN_QTY;
    var img = realImg();
    $('#mcpl-bar-img').innerHTML = img ? '<img src="' + esc(sized(img, 160)) + '" alt="">' : '';
    function st(done, label, val, target) {
      return '<button type="button" class="mcpl-st' + (done ? ' is-done' : '') + '" data-goto="' + target + '"><small>' + (done ? '✓ ' : '') + label + '</small><span>' + val + '</span></button>';
    }
    $('#mcpl-bar-steps').innerHTML =
      st(!!m, 'Model', m ? esc(m.name) : 'Choose', 'mcpl-s1') +
      st(!!l, 'Leather', l ? (l.hex ? '<i style="background:' + esc(l.hex) + '"></i>' : '') + esc(l.family + ' · ' + l.name) : 'Choose', 'mcpl-s2') +
      st(!!S.logo, 'Logo', S.logo ? esc(S.logo) : 'Choose', 'mcpl-s3') +
      st(S.qty >= MIN_QTY, 'Qty', S.qty + ' pcs', 'mcpl-s4');
    var next = !m ? 'Next: choose a model' : !l ? 'Next: choose leather and colour' : !S.logo ? 'Next: choose your logo finish' :
      S.qty < MIN_QTY ? 'Minimum ' + MIN_QTY + ' pieces per style and colour' : 'Ready – add it to your collection';
    $('#mcpl-hint').textContent = next;
    $('#mcpl-add').disabled = !ok;
  }

  /* ---------- events ---------- */
  var onClick = function (e) {
    var t;
    if ((t = e.target.closest('[data-type]'))) { S.type = t.getAttribute('data-type'); renderTypes(); renderModels(); return; }
    if ((t = e.target.closest('[data-name]'))) {
      var n = t.getAttribute('data-name');
      S.model = models.filter(function (x) { return x.name === n; })[0] || null;
      renderModels(); renderBar(); if (!S.leather) go('mcpl-s2'); return;
    }
    if ((t = e.target.closest('[data-fam]'))) { S.fam = +t.getAttribute('data-fam'); S.group = 'all'; renderFams(); renderColours(); return; }
    if ((t = e.target.closest('[data-group]'))) { S.group = t.getAttribute('data-group'); renderColours(); return; }
    if ((t = e.target.closest('[data-cards]'))) { openCards(+t.getAttribute('data-cards')); return; }
    if ((t = e.target.closest('[data-leather]'))) {
      var ci = +t.getAttribute('data-leather'), f = FAMS[S.fam], c = f.colours[ci];
      S.leather = { fam: S.fam, ci: ci, family: f.name, code: c.c, name: c.n, colourName: c.n, hex: c.h };
      renderColours(); renderBar(); if (!S.logo) go('mcpl-s3'); return;
    }
    if (e.target.closest('[data-code-ok]')) { useCode(); return; }
    if ((t = e.target.closest('[data-logo]'))) { S.logo = t.getAttribute('data-logo'); renderLogos(); renderBar(); go('mcpl-s4'); return; }
    if ((t = e.target.closest('[data-goto]'))) { go(t.getAttribute('data-goto')); return; }
    if (e.target.closest('#mcpl-add')) { addItem(); return; }
    if (e.target.closest('[data-open-collection]')) { if (window.MCCollection) MCCollection.open(); }
  };
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('#mcpl, .mcpl-bar')) return;
    try { onClick(e); } catch (err) { console.error('[MCPL]', err); }
  });
  document.addEventListener('keydown', function (e) { if (e.target.id === 'mcpl-code' && e.key === 'Enter') { e.preventDefault(); useCode(); } });
  function useCode() {
    var v = ($('#mcpl-code') || {}).value || ''; v = v.trim(); if (!v) return;
    var f = FAMS[S.fam], parts = v.split(/\s+/), code = /\d/.test(parts[0]) ? parts.shift().toUpperCase() : '';
    var name = parts.join(' ') || v;
    var found = -1;
    (f.colours || []).forEach(function (c, i) { if (found < 0 && code && c.c.toUpperCase() === code) found = i; });
    if (found > -1) { var c = f.colours[found]; S.leather = { fam: S.fam, ci: found, family: f.name, code: c.c, name: c.n, colourName: c.n, hex: c.h }; }
    else S.leather = { fam: S.fam, ci: -1, family: f.name, code: code, name: name, colourName: name, hex: '' };
    renderColours(); renderBar(); if (!S.logo) go('mcpl-s3');
  }
  document.addEventListener('input', function (e) {
    if (e.target.id === 'mcpl-search') { S.q = e.target.value.trim(); renderModels(); }
    if (e.target.id === 'mcpl-qty') { S.qty = parseInt(e.target.value, 10) || 0; renderBar(); }
  });

  function addItem() {
    if (!(S.model && S.leather && S.logo && S.qty >= MIN_QTY) || !window.MCCollection) return;
    MCCollection.add({
      model: S.model.name, type: S.model.type, img: realImg(), family: S.leather.family, code: S.leather.code,
      colour: S.leather.name, hex: S.leather.hex, logo: S.logo, qty: S.qty
    });
    var b = $('#mcpl-add'); b.textContent = '✓ Added'; setTimeout(function () { b.textContent = 'Add to my collection'; }, 1600);
    S.leather = null; renderColours(); renderBar(); go('mcpl-s2');
  }

  /* fixed bar only while the builder is on screen; moved to <body> (section transforms break position:fixed) */
  function barSync() {
    var bars = document.querySelectorAll('.mcpl-bar'), build = document.querySelector('.mcpl-build');
    if (!bars.length) return;
    var bar = bars[0];
    for (var i = 0; i < bars.length; i++) { if (bars[i].parentNode === document.body) bar = bars[i]; }
    for (var j = 0; j < bars.length; j++) { if (bars[j] !== bar) bars[j].remove(); }
    if (bar.parentNode !== document.body) document.body.appendChild(bar);
    var on = false;
    if (build) { var r = build.getBoundingClientRect(), h = window.innerHeight; on = r.top < h * 0.7 && r.bottom > 0; }
    bar.classList.toggle('is-on', on); document.body.classList.toggle('mcpl-bar-on', on);
  }
  window.addEventListener('scroll', barSync, { passive: true });
  window.addEventListener('resize', barSync);
  setInterval(barSync, 1000);
  barSync();

  renderFams(); renderColours(); renderLogos(); renderBar();
})();
